/* eslint-disable no-nested-ternary */
// TODO: refactor this module to meet 'no-nested-ternary' rule
import React, { Component } from 'react';
import i18n from '../../config/i18n';

import {
  DOCTOR_ID,
  NURSE_ID,
  PATIENT_ID,
  ASSISTANT_ID,
} from '../../constants/RoleConstants';

const styles = {
  thead: {
    backgroundColor: '#FFFFF5',
    color: '#2D3E4F',
  },
  th: {
    fontSize: 18,
  },
  edit: {
    float: 'right',
  },
};

class RecommendationHeader extends Component {
  constructor(props) {
    super(props);
    this.addMedication = this.addMedication.bind(this);
    this.updateRecommendation = this.updateRecommendation.bind(this);
    this.cancel = this.cancel.bind(this);
    this.edit = this.edit.bind(this);
  }

  addMedication() {
    this.props.handleAddMedication();
  }

  updateRecommendation() {
    this.props.handleUpdateRecommendation();
  }

  cancel() {
    this.props.cancel();
  }

  edit() {
    this.props.edit();
  }

  render() {
    const {
      thead,
      th,
      edit,
    } = styles;
    const {
      user,
      isEditing,
    } = this.props;
    const isDoctor = user.profile.roleId === DOCTOR_ID;
    const isPatient = user.profile.roleId === PATIENT_ID;
    const isNurse = user.profile.roleId === NURSE_ID;
    const isAssistant = user.profile.roleId === ASSISTANT_ID;

    return (
      <thead style={thead}>
        <tr>
          <th colSpan="4" style={th}>
            {i18n.t('doctorRecommendations')}
            {
              isPatient ? null : (
                <span style={edit}>
                  {
                    isEditing ? (
                      <div className="btn-group">
                        {
                          isDoctor ? (
                            <button className="btn btn-sm btn-info" onClick={this.addMedication}>
                              {i18n.t('addMedication')}
                            </button>
                          ) : null
                        }
                        <button
                          className="btn btn-sm btn-success"
                          onClick={this.updateRecommendation}
                        >
                          {i18n.t('save')}
                        </button>
                        <button className="btn btn-sm btn-default" onClick={this.cancel}>
                          {i18n.t('cancel')}
                        </button>
                      </div>
                    ) : (
                      (isNurse || isAssistant) ? '' : (
                        <button className="btn btn-sm btn-info" onClick={this.edit}>
                          {i18n.t('edit')}
                        </button>
                      )
                    )
                  }
                </span>
              )
            }
          </th>
        </tr>
      </thead>
    );
  }
}

export default RecommendationHeader;



// WEBPACK FOOTER //
// ./src/components/patient/RecommendationHeader.js